import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

/** Angular `/settings/workspaces` typo path -> workspace settings. */
const WorkspacesIndexRedirect = (): JSX.Element => <Navigate to="/settings/workspace" />;

export const Route = createFileRoute("/_app/settings/workspaces/")({
	component: WorkspacesIndexRedirect,
});
